import React, {useEffect, useState} from "react";


const VerticalVector = (props) => {
    const [number, setNumber] = useState(0); // State for the number
    useEffect(() => {
        setNumber(0)
        const interval = setInterval(() => {
            setNumber(prevNumber => {
                if (prevNumber < (props.denominator > 0 ? parseInt(100*props.numerator / props.denominator) : 0)) {
                    return prevNumber + 1; // Increment number from 1 to 100
                } else {
                    clearInterval(interval); // Stop the interval when number reaches 100
                    return (props.denominator > 0 ? parseInt(100*props.numerator / props.denominator) : 0); // Return the current number as 100
                }
            });
        }, 5);

        return () => clearInterval(interval); // Cleanup the interval on component unmount
    }, [props.denominator, props.numerator]); // Run only on component mount

    return (
        <div className="flex flex-col w-full h-full overflow-hidden rounded-[min(1vw,2vh)]">
            <div className={`flex flex-col justify-end items-center overflow-hidden text-[#001037] w-full h-[85%] bg-[#001037]`}>
                <div className={`flex justify-center text-[min(1.5vw,3vh)] rounded-t-[min(1vw,2vh)] items-center w-full bg-[${props.color}]`} style={{height : `${number}%`}}>
                    {number}%
                </div>
            </div>
            <div className="flex justify-center items-center w-full bg-white h-[8%] overflow-hidden text-[min(1vw,2vh)]">
                {props.grade}
            </div>
            <div className="flex justify-center items-center text-[min(1.5vw,3vh)] text-white w-full h-[20%]" style={{backgroundColor : `${props.color}66`}}>
                {parseInt(props.denominator).toLocaleString()}
            </div>
        </div>
    );
};

export default VerticalVector;